import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"

const PromoThreeColumn = ({ items, title }) => {
  return (
    <section className="promo-three-column">
      <div className="promo-three-column__inner">
        {title && <h2>{parse(title)}</h2>}
        <div className="promo-three-column__items">
          {items?.length > 0 &&
            items?.map((item, index) => (
              <div key={index} className="promo-three-column__item">
                {item?.image && <Asset asset={item?.image} />}
                {item?.title && <h3>{parse(item?.title)}</h3>}
                {item?.richContent && (
                  <StructuredText data={item?.richContent} />
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default PromoThreeColumn

export const query = graphql`
  fragment PromoThreeColumnProps on DatoCmsPromoThreeColumn {
    ... on DatoCmsPromoThreeColumn {
      id
      title
      items {
        title
        image {
            ...InternalAssetProps
        }
        richContent {
            value
        }
      }
    }
  }
`
